<template>
    <el-dialog v-model="dialogShow" width="400px" title="请绑定手机号" center @close="closeEvent" :close-on-click-modal="false" modal-class="dialog-new-model">
        <div class="login-container">
            <div class="login-title">您的账号尚未绑定家长手机号</div>
            <div class="login-form">
                <el-form ref="loginRef" :model="formData" :rules="formRules">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="phone">
                                <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5">
                        <el-col :span="16">
                            <el-form-item prop="code">
                                <el-input v-model="formData.code" placeholder="请输入验证码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-button color="#ef8b25" plain @click="getCode">{{codeTime?`${codeTime}秒重新获取`:'获取验证码'}}</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div>
                <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="bindPhoneEvent">确认绑定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, defineProps, defineEmits } from 'vue';
import { bindPhone, sendCode, getUserInfo } from "@/api/common.js"
import { ElMessage } from 'element-plus'
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    phone: '',
    code: ''
})
const codeTime = ref(0)
let codeTimer = null
const emitList = defineEmits(['close'])
const formRules = {
    phone: [
        {
            message: '请输入手机号',
            required: true
        }
    ],
    code: [
        {
            message: '请输入验证码',
            required: true
        }
    ]
}

function bindPhoneEvent() {
    loginRef.value.validate(valid => {
        if (valid) {
            bindPhone(formData.value).then(res => {
                console.log(res)
                ElMessage.success('绑定成功')
                emitList('close')
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function getCode() {
    if (codeTime.value > 0) {
        return ElMessage.warning('倒计时结束后再发送')
    } else {
        loginRef.value.validateField(['phone'], valid => {
            if (valid) {
                const params = {
                    phone: formData.value.phone,
                    type: '05'
                }
                console.log(params)
                sendCode(params).then(res => {
                    ElMessage.success('验证码已发送')
                    codeTime.value = 60
                    codeTimer = setInterval(() => {
                        if (!codeTime.value) {
                            clearInterval(codeTimer)
                            codeTimer = null
                        } else {
                            codeTime.value--;
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err)
                })
            }
        })
    }
}

function closeEvent() {
    emitList('close')
}
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }
}
</style>


<style lang="scss">
.dialog-new-model {
    .el-dialog {
        background: url("@/assets/img/bg2.jpg") no-repeat;
        background-size: 100% 100%;
        .el-divider__text {
            background-color: transparent;
        }
    }
}
</style>